export const groupMemberAttributes = `
  id
  role
  group {
    id
    slug
    name
  }
`;
